import { Routes } from '@angular/router';
import { shareKeyMatcher } from '@public/src/app/share-key.matcher';

export const routes: Routes = [
  { path: 'indicator/:key', loadChildren: () => import('@public/src/app/screens/indicator-neo/indicator-neo.routes').then(r => r.hashKeyRoutes) },
  { path: 'indicators/:key', loadChildren: () => import('@public/src/app/screens/indicators-neo/indicators-neo.routes').then(r => r.hashKeyRoutes) },
  { path: 'fact/:key', redirectTo: 'indicator/:key' },
  { path: 'facts/:key', redirectTo: 'indicators/:key' },
  { path: 'aspect/:key', redirectTo: 'indicator/:key' },
  { path: 'aspects/:key', redirectTo: 'indicators/:key' },
  { path: 'aspects-neo/:key', redirectTo: 'indicators/:key' },
  { path: 'aspect-neo/:key', redirectTo: 'indicator/:key' },
  { path: 'profile/:key', loadChildren: () => import('@public/src/app/screens/profile-neo/profile-neo.routes').then(r => r.hashKeyRoutes) },
  { path: 'profile-neo/:key', redirectTo: 'profile/:key' },
  { matcher: shareKeyMatcher('indicator'), loadChildren: () => import('@public/src/app/screens/indicator-neo/indicator-neo.routes').then(r => r.shareRoutes) },
  { matcher: shareKeyMatcher('indicators'), loadChildren: () => import('@public/src/app/screens/indicators-neo/indicators-neo.routes').then(r => r.shareRoutes) },
  { matcher: shareKeyMatcher('profiles'), loadChildren: () => import('@public/src/app/screens/profile-neo/profile-neo.routes').then(r => r.shareRoutes) },
  { path: 'share/indicator/:key', redirectTo: 'pages/indicator/:key' },
  { path: 'share/indicators/:key', redirectTo: 'pages/indicators/:key' },
  { path: 'share/profile/:key', redirectTo: 'pages/profiles/:key' },
];
